var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tree-view',{attrs:{"data":_vm.json,"options":{rootObjectKey: "Tables"}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }